const stap3 = {
	init() {
		stap3.betalingstermijnCheck();
		stap3.nieuweArbodienstSelected();
		stap3.initEvents();
	},

	/**
	 * Koppel functies aan DOM-element gebeurtenissen
	 *
	 * @returns {void}
	 */
	initEvents() {
		document.getElementById('TERMIJN').addEventListener('change', stap3.betalingstermijnCheck);
		$('#nieuweArboSelect').on('change', stap3.nieuweArbodienstSelected);
	},

	/**
	 * Enable en disable de optie "maatschappij-incasso" ('Nota') wanneer maand, kwartaal of halfjaar wordt gekozen (afhankelijk van company)
	 *
	 * @returns {void}
	 */
	betalingstermijnCheck() {
		const termijnSelect = document.getElementById('TERMIJN');
		const kdInkassoSelect = document.getElementById('KD_INKASSO');

		if (termijnSelect && kdInkassoSelect) {
			const companyId = termijnSelect.dataset.companyId;

			// Definieer object met beperkte waarden per bedrijf
			const restrictedValues = {
				base: ['maand'],
				C028: ['maand', 'kwartaal', 'halfjaar'],
				C030: [],
				C032: ['maand', 'kwartaal', 'halfjaar'],
			};

			// Controleer of het bedrijfs-ID bestaat in de array met beperkte waarden
			const relevantCompanyId = restrictedValues.hasOwnProperty(companyId) ? companyId : 'base';

			// Schakel de 'Nota' optie uit wanneer de termijnwaarde beperkt is
			if (restrictedValues[relevantCompanyId].includes(termijnSelect.value)) {
				kdInkassoSelect.value = 'Automatische-incasso';
				const maatschappijIncassoOption = kdInkassoSelect.querySelector('option[value="Maatschappij-incasso"]');
				if (maatschappijIncassoOption) {
					maatschappijIncassoOption.disabled = true;
				}
			} else {
				const maatschappijIncassoOption = kdInkassoSelect.querySelector('option[value="Maatschappij-incasso"]');
				if (maatschappijIncassoOption) {
					maatschappijIncassoOption.disabled = false;
				}
			}

			// Activeer wijzigingsgebeurtenis op KD_INKASSO
			kdInkassoSelect.dispatchEvent(new Event('change'));
		}
	},

	/**
	 * Regelt zichtbaarheid en validatie van de Arbodienst sectie
	 *
	 * @returns {void}
	 */
	nieuweArbodienstSelected() {
		const nieuweArboSelect = document.getElementById('nieuweArboSelect');
		const nieuweArboInput = document.getElementById('nieuweArbo');

		if (nieuweArboSelect && nieuweArboInput) {
			// Controleer of de huidige inputwaarde niet in de selectopties staat
			if (!nieuweArboSelect.querySelector(`option[value="${nieuweArboInput.value}"]`)) {
				nieuweArboInput.dataset.validate = 'required';
				nieuweArboInput.classList.remove('d-none');
			}

			// Als er een specifieke Arbodienst is geselecteerd, update de inputwaarde
			if (nieuweArboSelect.value !== 'ONB') {
				nieuweArboInput.value = nieuweArboSelect.value;
			}

			// Behandel de 'Anders, namelijk...' optie (ONB)
			if (nieuweArboSelect.value === 'ONB') {
				// Als de huidige inputwaarde overeenkomt met een bestaande optie, maak het veld leeg
				if (nieuweArboSelect.querySelector(`option[value="${nieuweArboInput.value}"]`)) {
					nieuweArboInput.value = '';
				}
				nieuweArboInput.dataset.validate = 'required';
				nieuweArboInput.classList.remove('d-none');
			} else if (!nieuweArboInput.classList.contains('d-none')) {
				nieuweArboInput.dataset.validate = '';
				nieuweArboInput.classList.add('d-none');
			}
		}
	},
};

export default stap3;
